module.exports = __webpack_public_path__ + "static/media/quicktime.6f9f6805.svg";